import styled from 'styled-components';

export const ItemStatus = styled.div<{ $color: string; $background: string; $borderColor: string }>`
  display: flex;
  padding: 1px 8px;
  align-items: center;
  border-radius: 4px;
  gap: 6px;
  color: ${({ $color }) => $color};
  background-color: ${({ $background }) => $background};
  border: 1px solid ${({ $borderColor }) => $borderColor};
`;
